import { render, staticRenderFns } from "./Emergencia.vue?vue&type=template&id=4d06bda3&scoped=true&"
import script from "./Emergencia.vue?vue&type=script&lang=js&"
export * from "./Emergencia.vue?vue&type=script&lang=js&"
import style0 from "./Emergencia.vue?vue&type=style&index=0&id=4d06bda3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06bda3",
  null
  
)

export default component.exports